/* eslint-disable import/no-duplicates */
import Layouts from '../../layouts/Layouts';
import TopicBanner from '../../Components/topicBanner/TopicBanner';
import FrequentlyAskedQues from './frequentlyAskedQues/FrequentlyAskedQues';
import OnlineDoctorAvailable from '../../Components/onlineDoctorAvailable/OnlineDoctorAvailable';
import bnrImg from '../../assets/images/png/topicbnr2.png';
import bnrInnerImg from '../../assets/images/png/topicbanner-img4.png';
import onlineDoc1 from '../../assets/images/png/online-doc.png';
import onlineDoc2 from '../../assets/images/png/online-doc.png';
import onlineDoc3 from '../../assets/images/png/online-doc.png';
import onlineDoc4 from '../../assets/images/png/online-doc.png';
import HowItWorks from './howItWorks/HowItWorks';
import BenefitsOFOnlineConsult from './benefitsOFOnlineConsult/BenefitsOFOnlineConsult';
import ConsultDoctor from './consultDoctor/ConsultDoctor';

const onlineDoctors = [onlineDoc1, onlineDoc2, onlineDoc3, onlineDoc4];

function ConsultNow() {
  const showOnlineDoc = () => (
    <div className="showOnlineDoc">
      <OnlineDoctorAvailable userShow={3} userImages={onlineDoctors} />
      +195 Doctors are Available now`
    </div>
  );

  return (
    <Layouts>
      <section className="consultNow">
        <TopicBanner
          bgImg={bnrImg}
          img={bnrInnerImg}
          title="Take Online Doctor Consultation now"
          desc={showOnlineDoc()}
        />
        <HowItWorks />
        <BenefitsOFOnlineConsult />
        <ConsultDoctor />
        <FrequentlyAskedQues />
      </section>
    </Layouts>
  );
}
export default ConsultNow;
